export default {
  type: 'in_place',
  instanceName: 'registrar/zero/orgresult',
  modalClassName: 'registar-zero-user-result',
  fields: {
    selectOrg: { type: 'select' },
    address: { type: 'text' },
    executive: { type: 'text' },
    fullName: { type: 'text' },
    inn: { type: 'text' },
    kpp: { type: 'text' },
    ogrn: { type: 'text' },
    position: { type: 'text' },
    shortName: { type: 'text' }
  }
};



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/forms/registrarUserOrgResultFormConfig.js